/*
 * Vajihi Labs - Email Signature Builder
 * Preview scaling: renders the real 640px-wide signature markup at full
 * size, measures its natural height, then scales the whole thing down to
 * fit the available pane width via CSS transform — never by cropping or
 * re-rendering a shrunk version. The wrapper's height is set to the
 * *scaled* height so nothing overflows or gets clipped. Export/insert
 * paths never touch this — they always use lib/themes.ts's unscaled output
 * directly.
 */

const BASE_WIDTH = 640;

export function renderScaledPreview(wrapper: HTMLElement, stage: HTMLElement, html: string): void {
  stage.innerHTML = html;
  stage.style.width = `${BASE_WIDTH}px`;
  stage.style.transform = "none";
  const naturalHeight = stage.offsetHeight || 1;
  const availableWidth = wrapper.clientWidth || BASE_WIDTH;
  const scale = Math.min(1, availableWidth / BASE_WIDTH);
  stage.style.transform = `scale(${scale})`;
  wrapper.style.height = `${Math.max(1, Math.ceil(naturalHeight * scale))}px`;
}
